var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "DAV-workshop__trunk"
  }, [_c('component-title', {
    attrs: {
      "color": "green"
    },
    on: {
      "goPrev": _vm.goPrev
    }
  }), _c('div', {
    staticClass: "DAV-blockClass"
  }, [_c('div', {
    staticClass: "icon-wrap"
  }, [_vm._m(0), _c('ul', {
    staticClass: "icon-list"
  }, _vm._l(_vm.getPopup.value.iconFiles, function (icon) {
    return _c('li', {
      key: icon.id,
      class: {
        active: icon.id === _vm.getPopup.value.seleceId
      },
      on: {
        "click": function click($event) {
          return _vm.updateIcon(icon.id);
        }
      }
    }, [_c('span'), _c('div', {
      staticClass: "mask-icon",
      style: {
        'background-color': _vm.getPopup.value.color,
        '-webkit-mask-image': "url(".concat(icon.url, ")")
      }
    })]);
  }), 0)])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "DAV-titleBar"
  }, [_c('h4', [_vm._v("아이콘 라이브러리")])]);
}]

export { render, staticRenderFns }